import i18n from '@/i18n.js'

export default {
  automations: [],

  tableHeaders: [
    {text: 'Key', value: 'automation_key'},
    {text: 'Tenant', value: 'tenant_id'},
    {text: 'Pipeline ID', value: 'pipeline_id', sortable: false},
    {text: 'Trigger', value: 'automation_trigger', sortable: false},
    {text: 'Actions', value: 'actions', sortable: false}
  ],

  selectedAutomation: {},

  fields: [
    {
      name: 'automation_key',
      type: 'text',
      label: 'Key',
      rules: [
        v => !!v || i18n.t('form_rules.mandatory')
      ],
      autofocus: true,
      required: true,
      hide: false,
      value: null
    },
    {
      name: 'tenant_id',
      type: 'select',
      label: 'Tenant',
      items: [],
      itemText: 'title',
      itemValue: 'tenant_id',
      required: true,
      hide: false,
      chips: true,
      multiple: false,
      value: null
    },
    {
      name: 'pipeline_id',
      type: 'number',
      label: 'Pipeline ID',
      rules: [
        v => !!v || i18n.t('form_rules.mandatory'),
        v => v > 0 || i18n.t('form_rules.zero_or_positive')
      ],
      required: true,
      hide: false,
      value: null
    },
    {
      name: 'automation_trigger',
      type: 'select',
      label: 'Trigger',
      items: [],
      itemText: 'text',
      itemValue: 'value',
      required: true,
      hide: false,
      value: null
    },
    {
      name: 'fixed_param',
      type: 'text',
      label: 'Fixed Parameters',
      required: false,
      hide: false,
      value: '{}'
    },
    {
      name: 'active',
      type: 'switch',
      label: i18n.t('active'),
      value: true,
      hide: false
    }
  ]
}
